<div class="row animate fadeIn fast">
    <div class="col-12">
        <div class="card">
            <div class="card-body bg-white">

                <input #txtTermino type="text" class="form-control" placeholder="Search Area..." (keyup)="buscar(txtTermino.value)" />

            </div>
        </div>
    </div>
</div>

<!-- ** Alerta cargando datos -->

<div class="row animate fadeIn fast" *ngIf="cargando">
    <div class="col-12">

        <div class="alert alert-info text-center">
            <h4 class="alert-heading">Loading</h4>
            <i class="fa fa-refresh fa-spin fa-2x"></i>
            <p class="mb-0">Please wait</p>
        </div>


    </div>
</div>


<!-- *** Tabla de Datos del Areas -->

<div class="row animate fadeIn fast" *ngIf="!cargando">
    <div class="col-12">
        <div class="card">
            <div class="card-body">


                <div class="row">

                    <div class="col-8">
                        <h4 class="card-title">Areas ({{areas.length}})</h4>
                        <h6 class="card-subtitle">Areas Registered</h6>
                    </div>

                    <div class="col">
                        <div class="text-right">
                            <button class="btn btn-themecolor rounded-pill" (click)="abrirSweetAlert()">
                                <i class="fa fa-hospital-o"></i>
                                New Area
                                </button>
                        </div>
                    </div>

                </div>




                <div class="table-responsive">

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="w100">Image</th>
                                <th>Area Name</th>
                                <th class="text-nowrap w100">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of areas">
                                <td class="text-center">
                                    <img class="w100 pointer" [src]="item.img | imagen: 'areas'" [alt]="item.name" (click)="abrirModal( item )">
                                </td>
                                <td>
                                    <input type="text" class="form-control" placeholder="Nombre del item" [(ngModel)]="item.name" />
                                    <div class="row">
                                        <div class="col-md-10">
                                            <ol class="list-group list-group-numbered" *ngFor="let subarea of item.subareas; let i = index">
                                                <li class="list-group-item bg-light-primary p-2">{{i + 1}}. {{subarea.name}}
                                                    <button type="button" (click)="borrarSubArea( item, subarea )" class="pointer float-right" data-toggle="tooltip" data-original-title="Borrar SubArea">
                                                        <i class="fa fa-close text-danger"></i>
                                                    </button>
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-nowrap text-center">

                                    <button type="button" (click)="guardarCambios( item )" class="pointer" data-toggle="tooltip" data-original-title="Guardar Cambios">
                                        <i class="fa fa-save text-inverse m-r-10"></i>
                                    </button>
                                    <button type="button" (click)="editarArea( item )" class="pointer" data-toggle="tooltip" data-original-title="Edita Area">
                                        <i class="fa fa-edit text-inverse m-r-10"></i>
                                    </button>
                                    <button type="button" (click)="borrarArea( item )" class="pointer" data-toggle="tooltip" data-original-title="Borrar">
                                        <i class="fa fa-close text-danger"></i>
                                    </button>

                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <!-- **Paginacion -->
                    <ngb-pagination class="float-right" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" [maxSize]="maxSize" [rotate]="true" [ellipses]="false" [boundaryLinks]="false" aria-label="Default pagination" (pageChange)="refresData()"></ngb-pagination>

                </div>
                <!-- <button class="btn btn-secondary btn-sm mr-2">Anterior</button>
                <button class="btn btn-secondary btn-sm">Siguiente</button> -->

            </div>
        </div>
    </div>
</div>